import { Action } from 'redux';

import { RunFlow } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface RunFlowReduxAction extends Action {
  readonly selectedContent: IContentInfo[];
}

export function runFlow(selectedContent: IContentInfo[]): RunFlowReduxAction {
  return {
    type: RunFlow,
    selectedContent
  };
}

export const isRunFlowsAction = isActionFactory<RunFlowReduxAction>(RunFlow);
